module.exports = __webpack_public_path__ + "static/media/logo.revu.a4f39a76.png";